import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import PageHeader from "./components/PageHeader";
import Carrer from "./pages/Career/Career"
import About from "./pages/about/About";
import Services from "./pages/Services/Services";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import Home from "./pages/home/Home";
import Contact from "./pages/Contact/Contact";

const AppContent = () => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  // Dynamic Title Logic
  const getPageTitle = () => {
    const path = location.pathname.split("/")[1];
    if (!path) return "";
    return path.charAt(0).toUpperCase() + path.slice(1).replace(/-/g, ' ');
  };

  return (
    <div className="relative flex flex-col w-full min-h-screen font-sans antialiased bg-white">
      <ScrollToTop /> 
      {/* 1. Fixed Header */}
      <Header />

      {/* 2. Main Content Area */}
      <main className={`flex-grow ${!isHomePage ? "pt-[68px] md:pt-[115px]" : ""}`}>
        {/* Bhai yahan logic ye hai:
          Agar Home page NAHI hai, toh humne Header ki height (approx 115px) 
          jitni padding-top (pt) de di hai. Isse PageHeader niche sarak jayega.
        */}
        
        {!isHomePage && <PageHeader title={getPageTitle()} />}

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/career" element={<Carrer/>} />
          <Route path="/about" element={<About/>} />
          <Route path="/services" element={<Services/>} />
        </Routes>
      </main>

      {/* 3. Footer */}
      <Footer />
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;